{
  "home": "Home",
  "games": "Games",
  "casino": "Casino",
  "sports": "Sports",
  "bonuses": "Bonuses",
  "wallet": "Cashier",
  "menu": "Menu",
  "profile": "Account",
  "login": "Log in",
  "loginSoon": "Log in — soon",
  "vipCashback": "VIP Cashback",
  "invite": "Invite"
}
